import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

// Shared "refresh bus": instead of hard-reloading the whole app whenever the
// Firebase Realtime Database listener sees an order change, site-headers
// just calls triggerRefresh() and any order-list/detail component that is
// currently active re-fetches its own data via orderRefresh$.
@Injectable({ providedIn: 'root' })
export class OrderRefreshService {
  private refreshSubject = new Subject<void>();
  orderRefresh$ = this.refreshSubject.asObservable();

  triggerRefresh(): void {
    this.refreshSubject.next();
  }
}
